<template>
  <div class="committee-contract-type-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">{{ $t('committeeContractType.pageTitle') }}</div>
        <div class="figma-header-divider"></div>
        <div class="figma-header-row">
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn figma-btn-primary" @click="handleAdd">
              <i class="el-icon-plus"></i>{{ $t('committeeContractType.action.add') }}
            </el-button>
            <el-button size="small" class="figma-btn-refresh" :title="$t('committeeVoteManage.action.refresh')" @click="getList">
              <i class="el-icon-refresh-right"></i>
            </el-button>
          </div>
          <div class="figma-search-group">
            <el-input
              v-model="conditions.typeName"
              size="small"
              :placeholder="$t('committeeContractType.search.typeNamePlaceholder')"
              class="figma-search-input"
              clearable
              @keyup.enter.native="handleSearch"
            />
            <el-select
              v-model="conditions.audit"
              size="small"
              :placeholder="$t('committeeContractType.search.auditPlaceholder')"
              class="figma-search-input"
              clearable
              @change="handleSearch"
            >
              <el-option v-for="item in audits" :key="item.statusCd || item.value" :label="item.name || item.label" :value="item.statusCd || item.value" />
            </el-select>
            <el-button size="small" class="figma-btn-search" @click="handleSearch">
              <i class="el-icon-search"></i>
              <span>{{ $t('committeeVoteManage.action.search') }}</span>
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :fit="true"
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
        >
          <el-table-column prop="communityName" :label="$t('committeeContractType.table.communityName')" min-width="140" show-overflow-tooltip />
          <el-table-column prop="typeName" :label="$t('committeeContractType.table.typeName')" min-width="160" show-overflow-tooltip />
          <el-table-column prop="auditName" :label="$t('committeeContractType.table.audit')" min-width="100" show-overflow-tooltip />
          <el-table-column prop="remark" :label="$t('committeeContractType.table.remark')" min-width="240" show-overflow-tooltip />
          <el-table-column prop="createTime" :label="$t('committeeContractType.table.createTime')" min-width="170" show-overflow-tooltip />
          <el-table-column :label="$t('committeeContractType.table.action')" min-width="220" align="center">
            <template slot-scope="scope">
              <div class="action-links">
                <a class="action-link" @click="handleSpec(scope.row)">{{ $t('committeeContractType.action.spec') }}</a>
                <span class="link-space"></span>
                <a class="action-link" @click="handleTemplate(scope.row)">{{ $t('committeeContractType.action.template') }}</a>
                <span class="link-space"></span>
                <a class="action-link" @click="handleEdit(scope.row)">{{ $t('committeeContractType.action.edit') }}</a>
                <span class="link-space"></span>
                <a class="action-link" @click="handleDelete(scope.row)">{{ $t('committeeContractType.action.delete') }}</a>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="figma-pagination">
        <span class="pagination-total">共{{ pagination.total }}条</span>
        <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.row"
          layout="prev, pager, next"
          :total="pagination.total"
          @current-change="handlePageChange"
        />
        <el-select v-model="pagination.row" size="small" class="pagination-size-select" @change="handleSizeChange">
          <el-option label="10条/页" :value="10" />
          <el-option label="20条/页" :value="20" />
          <el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>

    <!-- 添加/编辑合同类型弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="650px"
      custom-class="contract-type-dialog"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="formRules"
        label-width="120px"
        label-position="right"
        class="contract-type-form-body"
      >
        <el-form-item :label="$t('committeeContractType.form.community') + '：'" prop="communityId" required>
          <el-select v-model="form.communityId" filterable :placeholder="$t('committeeContractType.form.community') + '请选择'" style="width: 100%">
            <el-option v-for="item in myCommunities" :key="item.communityId" :label="item.name" :value="item.communityId" />
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('committeeContractType.form.typeName') + '：'" prop="typeName" required>
          <el-input v-model="form.typeName" :placeholder="$t('committeeContractType.form.typeNamePlaceholder')" />
        </el-form-item>

        <el-form-item :label="$t('committeeContractType.form.audit') + '：'" prop="audit" required>
          <el-select v-model="form.audit" style="width: 100%" :placeholder="$t('committeeContractType.search.auditPlaceholder')">
            <el-option v-for="item in audits" :key="item.statusCd || item.value" :label="item.name || item.label" :value="item.statusCd || item.value" />
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('committeeContractType.form.remark') + '：'" prop="remark">
          <el-input v-model="form.remark" :placeholder="$t('committeeContractType.form.remarkPlaceholder')" />
        </el-form-item>
      </el-form>

      <span slot="footer" class="contract-type-footer">
        <el-button class="contract-type-btn-cancel" @click="dialogVisible = false">{{ $t('committeeContractType.dialog.cancel') }}</el-button>
        <el-button class="contract-type-btn-save" :loading="submitting" @click="submitForm">{{ $t('committeeContractType.dialog.save') }}</el-button>
      </span>
    </el-dialog>

    <add-template-view ref="addTemplateView" @success="getList" />
  </div>
</template>

<script>
import { getCommunityId, getDict } from '@/api/community/communityApi'
import { listCommunitysByOwnerCommittee } from '@/api/owner/ownerCommitteeManageApi'
import { queryContractType, saveContractType, updateContractType, deleteContractType } from '@/api/contract/contractTypeManageApi'
import AddTemplateView from '@/components/contract/addTemplateView'

export default {
  name: 'CommitteeContractTypeList',
  components: { AddTemplateView },
  data() {
    return {
      loading: false,
      submitting: false,
      dialogVisible: false,
      dialogMode: 'add',
      conditions: { typeName: '', audit: '' },
      audits: [],
      myCommunities: [],
      tableData: [],
      pagination: { total: 0, page: 1, row: 10 },
      form: this.getDefaultForm(),
      formRules: {
        communityId: [
          { required: true, message: this.$t('committeeContractType.validate.community'), trigger: 'change' }
        ],
        typeName: [
          { required: true, message: this.$t('committeeContractType.validate.typeName'), trigger: 'blur' }
        ],
        audit: [
          { required: true, message: this.$t('committeeContractType.validate.audit'), trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.dialogMode === 'add' ? this.$t('committeeContractType.dialog.addTitle') : this.$t('committeeContractType.dialog.editTitle')
    }
  },
  created() { this.initPage() },
  methods: {
    getDefaultForm() {
      return { contractTypeId: '', communityId: '', typeName: '', audit: '', remark: '' }
    },
    headerCellStyle() {
      return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '400', fontFamily: 'PingFang SC', height: '50px' }
    },
    cellStyle({ row }) {
      const rowIndex = this.tableData.indexOf(row)
      const base = { color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px', fontWeight: rowIndex % 2 === 1 ? '500' : '400' }
      return rowIndex % 2 === 1 ? { ...base, background: '#F8FBFF' } : { ...base, background: 'white' }
    },
    isSuccess(res) {
      return res && (res.code === 0 || res.code === 200 || res.code === '0' || res.code === '200' || res.success || res.msg === 'success')
    },
    getListArray(res) {
      if (Array.isArray(res)) return res
      if (Array.isArray(res && res.data)) return res.data
      if (Array.isArray(res && res.records)) return res.records
      if (Array.isArray(res && res.rows)) return res.rows
      if (Array.isArray(res && res.contractTypes)) return res.contractTypes
      return []
    },
    getTotal(res, list) {
      return Number((res && (res.total || res.count || res.totalCount)) || list.length || 0)
    },
    async initPage() {
      await Promise.all([this.loadAudits(), this.loadCommunities()])
      this.getList()
    },
    async loadAudits() {
      try {
        const res = await getDict('contract_type', 'audit')
        const list = Array.isArray(res) ? res : this.getListArray(res)
        this.audits = list.length ? list : [{ name: '审核', statusCd: 'Y' }, { name: '不审核', statusCd: 'N' }]
      } catch (e) {
        this.audits = [{ name: '审核', statusCd: 'Y' }, { name: '不审核', statusCd: 'N' }]
      }
    },
    async loadCommunities() {
      try {
        const res = await listCommunitysByOwnerCommittee({ page: 1, row: 1000 })
        this.myCommunities = res.data || []
      } catch (e) {
        this.myCommunities = []
      }
    },
    normalizeRow(row, index) {
      let communityName = row.communityName
      if (!communityName && row.communityId) {
        const community = this.myCommunities.find(c => c.communityId === row.communityId)
        communityName = community ? community.name : row.communityId
      }
      return {
        ...row,
        id: row.id || row.contractTypeId || index + 1,
        communityName: communityName || '-',
        typeName: row.typeName || '',
        auditName: row.auditName || this.getAuditName(row.audit),
        remark: row.remark || row.typeDesc || '-',
        createTime: row.createTime || ''
      }
    },
    getAuditName(audit) {
      const item = this.audits.find(a => (a.statusCd || a.value) === audit)
      return item ? (item.name || item.label) : audit
    },
    async getList() {
      try {
        this.loading = true
        const res = await queryContractType({
          page: this.pagination.page,
          row: this.pagination.row,
          typeName: this.conditions.typeName,
          audit: this.conditions.audit,
          communityIds: this.myCommunities.map(c => c.communityId).join(',')
        })
        const list = this.getListArray(res)
        this.tableData = list.map((item, index) => this.normalizeRow(item, index))
        this.pagination.total = this.getTotal(res, list)
      } catch (e) {
        this.$message.error(this.$t('committeeContractType.message.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.pagination.page = 1; this.getList() },
    handleAdd() {
      this.dialogMode = 'add'
      this.form = this.getDefaultForm()
      let defaultCommunityId = getCommunityId()
      if ((!defaultCommunityId || defaultCommunityId === '-1') && this.myCommunities.length) {
        defaultCommunityId = this.myCommunities[0].communityId
      }
      this.form.communityId = defaultCommunityId
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    handleEdit(row) {
      this.dialogMode = 'edit'
      this.form = {
        contractTypeId: row.contractTypeId,
        communityId: row.communityId || getCommunityId(),
        typeName: row.typeName,
        audit: row.audit,
        remark: row.remark === '-' ? '' : row.remark
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    handleSpec(row) {
      this.$router.push({
        path: '/pages/committee/contractTypeSpecDetail',
        query: { contractTypeId: row.contractTypeId, typeName: row.typeName }
      })
    },
    handleTemplate(row) {
      this.$refs.addTemplateView.open(row)
    },
    async submitForm() {
      const valid = await this.$refs.form.validate().catch(() => false)
      if (!valid) return
      try {
        this.submitting = true
        const api = this.dialogMode === 'add' ? saveContractType : updateContractType
        const res = await api(this.form)
        if (!this.isSuccess(res)) throw new Error((res && res.msg) || this.$t('committeeContractType.message.saveError'))
        this.$message.success(this.$t('committeeContractType.message.saveSuccess'))
        this.dialogVisible = false
        this.getList()
      } catch (e) {
        this.$message.error(e.message || this.$t('committeeContractType.message.saveError'))
      } finally {
        this.submitting = false
      }
    },
    handleDelete(row) {
      this.$confirm(this.$t('committeeContractType.dialog.deleteConfirm'), this.$t('committeeContractType.dialog.deleteTitle'), { type: 'warning' }).then(async () => {
        const res = await deleteContractType({ contractTypeId: row.contractTypeId, communityId: row.communityId || getCommunityId() })
        if (!this.isSuccess(res)) throw new Error((res && res.msg) || this.$t('committeeContractType.message.deleteError'))
        this.$message.success(this.$t('committeeContractType.dialog.deleteSuccess'))
        this.getList()
      }).catch(e => {
        if (e && e.message) this.$message.error(e.message)
      })
    },
    handlePageChange(page) { this.pagination.page = page; this.getList() },
    handleSizeChange(size) { this.pagination.row = size; this.pagination.page = 1; this.getList() }
  }
}
</script>

<style scoped>
.committee-contract-type-page { height: calc(100vh - 60px); background: #EBF2FA; padding: 0; overflow: hidden; box-sizing: border-box; display: flex; flex-direction: column; }
.figma-white-card { background: white; border-radius: 0 0 12px 12px; flex: 1; min-height: 0; display: flex; flex-direction: column; }
.figma-page-header { display: flex; flex-direction: column; align-items: flex-start; padding: 20px 24px 12px; gap: 12px; flex-shrink: 0; }
.figma-page-title { font-size: 16px; font-weight: 600; color: #1D2129; font-family: 'PingFang SC'; line-height: 22px; }
.figma-header-divider { width: 100%; height: 1px; background: #DCE6F5; }
.figma-header-row { display: flex; align-items: center; justify-content: space-between; width: 100%; }
.figma-btn-group { display: flex; align-items: center; gap: 12px; }
.figma-btn { height: 38px; min-width: 82px; border-radius: 10px !important; border: none !important; color: white !important; font-size: 14px; font-weight: 500; padding: 0 16px; display: inline-flex; align-items: center; justify-content: center; }
.figma-btn i { margin-right: 6px; }
.figma-btn-primary { background: #0E76FF !important; }
.figma-btn-audit { min-width: 135px; background: #0E76FF !important; }
.figma-btn-refresh { height: 38px; width: 38px; border-radius: 10px !important; border: 1px solid #DCE6F5 !important; background: white !important; color: #6A7282 !important; display: inline-flex; align-items: center; justify-content: center; padding: 0; }
.figma-btn-refresh:hover { border-color: #0E76FF !important; color: #0E76FF !important; }
.figma-search-group { display: flex; align-items: center; gap: 12px; margin-left: auto; }
.figma-search-input { width: 256px; height: 38px; }
.figma-search-input >>> .el-input__inner { border-radius: 10px; border: none; outline: 1px #DCE6F5 solid; outline-offset: -1px; height: 38px; font-size: 14px; background: white; color: #1D2129; }
.figma-search-input >>> .el-input__inner:focus { outline-color: #0E76FF; }
.figma-btn-search { width: 74px; height: 38px; border-radius: 10px !important; border: none !important; outline: 1px #0E76FF solid !important; outline-offset: -1px; color: #0E76FF !important; background: white !important; font-size: 14px; font-weight: 500; padding: 0; display: inline-flex; align-items: center; justify-content: center; gap: 6px; }
.figma-btn-search:hover { background: rgba(14, 118, 255, 0.08) !important; }
.figma-table-section { flex: 1; min-height: 0; padding: 12px 24px 0; overflow: auto; }
.figma-table-section >>> .el-table { border-radius: 8px; overflow: hidden; border: none; }
.figma-table-section >>> .el-table::before { display: none; }
.figma-table-section >>> .el-table__header th { background: #EBF2FA !important; border: none !important; }
.figma-table-section >>> .el-table__body td { border: none !important; }
.action-links { display: flex; align-items: center; justify-content: center; white-space: nowrap; }
.action-link { color: #0E76FF; font-size: 14px; cursor: pointer; text-decoration: none; font-weight: 400; }
.action-link:hover { opacity: 0.85; }
.link-space { width: 12px; display: inline-block; }
.figma-pagination { display: flex; align-items: center; justify-content: flex-end; padding: 16px 24px 24px; gap: 8px; flex-shrink: 0; }
.pagination-total { font-size: 14px; color: #1D2129; margin-right: 4px; }
.figma-pagination >>> .el-pagination { display: flex; align-items: center; padding: 0; }
.figma-pagination >>> .btn-prev,
.figma-pagination >>> .btn-next { width: 32px; height: 32px; border-radius: 2px; background: white; }
.figma-pagination >>> .el-pager li { min-width: 32px; height: 32px; line-height: 32px; border-radius: 8px; color: #1D2129; font-weight: 600; }
.figma-pagination >>> .el-pager li.active { background: #E8F3FF; color: #0E76FF; }
.pagination-size-select { width: 92px; margin-left: 8px; }
.pagination-size-select >>> .el-input__inner { height: 32px; border-radius: 8px; background: #F2F3F5; border: none; font-size: 14px; color: #1D2129; }

/* 弹窗样式 */
.committee-contract-type-page >>> .contract-type-dialog { border-radius: 12px; overflow: hidden; }
.committee-contract-type-page >>> .contract-type-dialog .el-dialog__header {
  height: 66px; box-sizing: border-box; padding: 22px 24px;
  background: #EBF2FA; border-bottom: 1px solid #DCE6F5;
}
.committee-contract-type-page >>> .contract-type-dialog .el-dialog__title {
  font-size: 16px; color: #1D2129; font-weight: 600;
}
.committee-contract-type-page >>> .contract-type-dialog .el-dialog__body {
  padding: 24px 24px 8px;
}
.committee-contract-type-page >>> .contract-type-dialog .el-dialog__footer {
  padding: 8px 24px 28px;
  display: flex; justify-content: flex-end; gap: 12px;
}
.contract-type-form-body .el-form-item { margin-bottom: 20px; }
.contract-type-form-body .el-form-item:last-child { margin-bottom: 0; }
.contract-type-form-body >>> .el-form-item { display: flex; align-items: center; }
.contract-type-form-body >>> .el-form-item__label {
  font-size: 14px; font-weight: 500; color: #1D2129;
  line-height: 40px; height: 40px; float: none;
}
.contract-type-form-body >>> .el-form-item__content {
  flex: 1; margin-left: 0 !important; line-height: 40px;
}
.contract-type-form-body >>> .el-form-item.is-required >>> .el-form-item__label::before {
  color: #FB2C36; margin-right: 4px;
}
.contract-type-form-body >>> .el-input__inner {
  border-radius: 10px; border: 1px solid #DCE6F5;
  font-size: 14px; color: #1D2129; height: 40px;
}
.contract-type-form-body >>> .el-input__inner:focus {
  border-color: #0E76FF;
}
.contract-type-form-body >>> .el-select >>> .el-input__inner {
  height: 40px;
}
.contract-type-footer { display: flex; justify-content: flex-end; gap: 12px; }
.contract-type-btn-cancel {
  width: 98px; height: 38px; border-radius: 10px !important;
  color: #0E76FF !important; border-color: #0E76FF !important;
  background: white !important;
}
.contract-type-btn-save {
  width: 98px; height: 38px; border-radius: 10px !important;
  background: #0E76FF !important; color: white !important;
  border-color: #0E76FF !important;
}

@media (max-width: 1024px) {
  .figma-header-row { align-items: flex-start; gap: 12px; flex-direction: column; }
  .figma-btn-group { flex-wrap: wrap; }
  .figma-search-group { width: 100%; margin-left: 0; }
  .figma-search-input { width: min(256px, calc(100vw - 150px)); }
}
</style>
